import { useRouter } from 'next/router';
import { memo } from 'react';

import Redirect from 'components/common/redirect';
import Text from 'components/common/text';
import Title from 'components/common/title';
import { AuthContent } from 'components/layout/auth-layout/styles';
import { SignUpFormWrapper } from './styles';
import SignUpWithCredentials from './SignUpWithCredentials';
import SignUpWithGoogle from './SignUpWithGoogle';

function SignUpForm() {
  const { query } = useRouter();

  return typeof query.address === 'string' && query.address ? (
    <AuthContent>
      <SignUpFormWrapper>
        <Title type="mode1" fw="light" className="sign-up-title">
          One Step Closer to
        </Title>
        <Title type="mode1" fw="bold" className="sign-up-subtitle">
          Selling Your Home
        </Title>
        <Text type="mode4" fw="bold" className="sign-up-address">
          {`"${query.address}"`}
        </Text>
        <SignUpWithGoogle />

        <Text className="or-line">
          <span />
          Or Enter Your Details Below
          <span />
        </Text>
        <SignUpWithCredentials />
        <div className="bottom-text">
          <Text fw="light" type="mode2">
            By signing up to Richr, you consent and agree that Richr and its
            affiliates may use automated technology, including pre-recorded
            messages, cell phones, and texts, and email to contact you at the
            number and email address you provided. This includes if your number
            is currently on any Do Not Call Lists. Consent is not required to
            make a purchase. Message and data rates may apply. You also agree to
            Our Terms of Service.
          </Text>
        </div>
      </SignUpFormWrapper>
    </AuthContent>
  ) : (
    <Redirect pathname="/" replace />
  );
}

export default memo(SignUpForm);
